module.exports = __webpack_public_path__ + "static/media/text-t.c65ba9a0.svg";